"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by mariam.melkonyan on 5/18/17.
 */
const measure_model_1 = require("../../../shared/model/measure.model");
class PieChartReportModel {
    constructor() {
        /**
         * The row category id of the chart
         * @type {number}
         * @private
         */
        this._category = null;
        /**
         * The list of measures of the chart
         * @type {Array.<number>}
         * @private
         */
        this._measures = [];
        /**
         * The top count of the report data that should be shown in chart
         * @type {number}
         * @private
         */
        this._top = 10;
    }
    get category() {
        return this._category;
    }
    set category(category) {
        this._category = category !== undefined ? category : null;
    }
    get measures() {
        return this._measures;
    }
    set measures(measures) {
        this._measures = measures;
    }
    get top() {
        return this._top;
    }
    set top(top) {
        this._top = top || 10;
    }
    validate() {
        if (this.measures === null || this.measures.length === 0) {
            return false;
        }
        if (this.category !== null && this.measures.length > 1) {
            return false;
        }
        return true;
    }
    toJson() {
        let jsonObject = {};
        jsonObject.category = this.category;
        jsonObject.measures = this.measures;
        jsonObject.top = this.top;
        return JSON.stringify(jsonObject);
    }
    fromJson(jsonObject) {
        this.category = jsonObject.category == undefined ? null : jsonObject.category;
        this.measures = jsonObject.measures == undefined ? null :
            jsonObject.measures
                .map(measure => measure_model_1.MeasureModel.fromJSON(measure));
        this.top = jsonObject.top;
    }
}
exports.PieChartReportModel = PieChartReportModel;
//# sourceMappingURL=pie-chart-report.model.js.map